import React from 'react'
import { Typography } from '@mui/material'
import { toLocale } from '$func/text'

const digit2converter = (number: number) => `${number > 9 ? '' : '0'}${number}`

const formatter = (duration: number) => {
  const date = new Date(duration)
  const minutes = date.getUTCMinutes()
  const seconds = digit2converter(date.getUTCSeconds())
  const deciSeconds = Math.round(date.getUTCMilliseconds() / 100)

  return toLocale(`${minutes}:${seconds}.${deciSeconds}`)
}

export function durationLabelRenderer(duration: number) {
  return (
    <Typography variant="subtitle1" color="gray">
      {formatter(duration)}
    </Typography>
  )
}
